import { useAuth0 } from '@auth0/auth0-react';
import { OnboardingShell } from '../OnboardingShell';

export const WelcomeStep = (props) => {
	const { stepIndex, totalSteps, onNext } = props;
	const { user } = useAuth0();

	const firstName = user?.given_name || (user?.name ? user.name.split(' ')[0] : '') || (user?.email ? user.email.split('@')[0] : '');
	const greeting = firstName ? `Welcome, ${firstName}` : 'Welcome to WagerWiz';

	const features = [
		{
			icon: '+',
			title: 'Find +EV bets',
			desc: 'See every profitable wager across 20+ sportsbooks in real time.',
		},
		{
			icon: '\u21C4',
			title: 'Spot arbitrage instantly',
			desc: 'Lock in guaranteed-profit opportunities the moment lines move.',
		},
		{
			icon: '\u26A1',
			title: 'Move faster than the books',
			desc: 'Live odds, smart alerts, and tools built for sharp bettors.',
		},
	];

	return (
		<OnboardingShell
			stepIndex={stepIndex}
			totalSteps={totalSteps}
			title={greeting}
			subtitle="Let's get you set up in under a minute."
			showBack={false}
			onContinue={onNext}
			continueLabel="Get started">
			<div className="py-2">
				{features.map((f) => (
					<div key={f.title} className="ob-feature-row">
						<div className="ob-feature-icon">{f.icon}</div>
						<div>
							<div className="font-semibold text-[15px] text-white">{f.title}</div>
							<div className="text-[13px] text-[#a8aebd] mt-0.5">{f.desc}</div>
						</div>
					</div>
				))}
			</div>
		</OnboardingShell>
	);
};
